export const base64Encode = (plainString: string) => {
    if (typeof window === 'undefined') {
        return Buffer.from(plainString).toString('base64')
    }
    return window.btoa(plainString)
};

export const base64Decode = (encodedString: string) => {
    if (typeof window === 'undefined') {
        return Buffer.from(encodedString, 'base64').toString('utf-8');
    }
    return window.atob(encodedString);
}

export const tryParseJSON = <T>(text?: string) => {
    if (!text) {
        return null;
    }
    try {
        const val = JSON.parse(text);
        if (val && val instanceof Array || val instanceof Object) {
            return val as T;
        }
    }
    catch (_e) {
        return null;
    }
    return null;
}

export function tryParseDate(dateValue?: any) {
    if (dateValue) {
        const date = new Date(dateValue);
        if (date.getTime() > 0) {
            return date;
        }
    }
    return null;
}

const isDevelopment = (baseUrl: string) => process.env.NODE_ENV === "development" || /(?:localhost|127.0.0.1)/.test(baseUrl);
const envId = (baseUrl: string) => (baseUrl).match(/ecommerce\.([a-z]*)\.4patriots\.net/)?.at(1);

export const cookieDomain = (baseUrl?: string) => {
    const hostname = baseUrl ? new URL(baseUrl).hostname.replace('www.', '') : 'localhost';
    const domain = hostname !== 'localhost' ? `.${hostname}` : undefined;
    return domain;
}

export const cookieSameSite = (baseUrl?: string, secure?: boolean) => {
    if (secure) {
        if (isDevelopment(baseUrl ?? 'http://localhost:3000')) {
            return 'none';
        }
        const env = envId(baseUrl ?? 'http://localhost:3000');
        if (env === 'sb' || env === 'qa') {
            return 'none';
        }
    }

    return 'lax';
}

export const cookieSecure = (baseUrl?: string) => {
    return baseUrl?.startsWith("https://");
}
